module.exports = __webpack_public_path__ + "img/요양산업.6660563d.png";